import {
  ENDPOINT_PANEL_REVIEW_SESSION,
  ENDPOINT_CONFIGURATION,
  ENDPOINT_PANEL_REVIEW_APPLICATION,
} from 'common/endpoints';
import _ from 'lodash';
import {commonJwtHeader} from 'common/utils';

// TODO, remove this after panelReviewV2 goes live in PROD
const getRequestOptions = (token) => ({
  method: 'GET',
  headers: commonJwtHeader(),
});

const getApplicationScores = (token, applicationId) =>
  fetch(`${ENDPOINT_PANEL_REVIEW_APPLICATION}` + `${applicationId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });

const getSessionInfo = (token, sessionId) =>
  fetch(ENDPOINT_PANEL_REVIEW_SESSION(sessionId), getRequestOptions(token));
const getSessionConfig = (token, foId) => {
  return fetch(
    `${ENDPOINT_CONFIGURATION}fo/${foId}/panels/sessionConfig`,
    getRequestOptions(token)
  );
};

export default {
  getSessionInfo,
  getSessionConfig,
  getApplicationScores,
};
